import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d91e64fa"
import script from "./customerDirectTax.js?vue&type=script&lang=js&external"
export * from "./customerDirectTax.js?vue&type=script&lang=js&external"
import style0 from "./customerDirectTax.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports